import React from 'react'

class LogoInegration extends React.Component {
    render() {
        return (

            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 500 500">
                <g fill="none" fill-rule="evenodd">
                    <path fill="#B394C5" d="M301.968 124.838c-.196-2.484-.66-5.108-1.612-7.992C281.852 60.99 209.912 7.97 225.832 35.714c15.92 27.748-8.424 74.316-17.368 58.744-8.94-15.568-37.996-30.588-30.656-17.656 4.072 7.176.82 17.532-2.876 25.34-15.02 2.284-31.476 5.704-49.544 10.48-11.06 2.924-27.092 8.952-41.14 21.344-10.44-8.796-27.2-20.052-41.548-16.596 0 0 7.116 27.432 23.944 38.372-1.072 1.908-2.076 3.908-3.032 5.976C53.272 153.894 39.264 146.09 27 149.05c0 0 8.408 32.372 28.552 40.788-1.128 8.008-1.532 16.804-1.028 26.5 0 0-32.008 139.164-11.364 196.884 0 0 73.388 49.344 118.892 62.22 0 0 95.632-88.7 108.488-141.256l-31.012-72.46c.272-16.86 10.664-31.952 26.38-38.056 20.868-8.1 47.72-20.592 53.94-33.136 5.236-10.572 6.236-42.42-17.88-65.696"/>
                    <path fill="#FEFEFE" d="M160.572 183.696l5.416-31.628-5.564-.956L155 182.74"/>
                    <path fill="#FEFEFE" d="M175.628 173.104L144 167.684l.952-5.572 31.628 5.424"/>
                </g>
            </svg>

        );
    }
}

export default LogoInegration



// WEBPACK FOOTER //
// ../components/SVG/LogoInegration.jsx